/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseActionContextRequest
 */
export interface ResponseActionContextRequest {
    /**
     * 
     * @type {string}
     * @memberof ResponseActionContextRequest
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseActionContextRequest
     */
    entityId?: string;
}

/**
 * Check if a given object implements the ResponseActionContextRequest interface.
 */
export function instanceOfResponseActionContextRequest(value: object): value is ResponseActionContextRequest {
    return true;
}

export function ResponseActionContextRequestFromJSON(json: any): ResponseActionContextRequest {
    return ResponseActionContextRequestFromJSONTyped(json, false);
}

export function ResponseActionContextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseActionContextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
    };
}

export function ResponseActionContextRequestToJSON(json: any): ResponseActionContextRequest {
    return ResponseActionContextRequestToJSONTyped(json, false);
}

export function ResponseActionContextRequestToJSONTyped(value?: ResponseActionContextRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityId': value['entityId'],
    };
}

